import { Link } from "@icg360/design-system";

import logo from "../../../assets/logo-horz-full-color-opt.svg";
import styles from "./Header.module.css";

interface HeaderProps {
  quoteNumber: string | number;
  policyPeriod: string;
  insuranceCarrier: string;
  insuranceCarrierUrl: string;
}

export const Header = ({
  quoteNumber,
  policyPeriod,
  insuranceCarrier,
  insuranceCarrierUrl
}: HeaderProps) => (
  <div className={styles.headerContainer}>
    <img src={logo} alt="SageSure Logo" width={224} height={50} />
    <div className={styles.headerFields}>
      <p>{quoteNumber}</p>
      <p>{policyPeriod}</p>
      <Link href={insuranceCarrierUrl}>{insuranceCarrier}</Link>
    </div>
  </div>
);
